import { FC, ReactElement } from 'react';

import { HashRouter, Route, Routes } from 'react-router-dom';

import About from './pages/About';
import Contact from './pages/Contact';
import Crew from './pages/Crew';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import SWOT from './pages/SWOT';

const App: FC = (): ReactElement => {
  return (
    <HashRouter>
      <Routes>
        <Route element={<About />} path='/sobre' />
        <Route element={<Contact />} path='/fale-conosco' />
        <Route element={<Crew />} path='/equipe' />
        <Route element={<Home />} path='/' />
        <Route element={<SWOT />} path='/swot' />
        <Route element={<NotFound />} path='*' />
      </Routes>
    </HashRouter>
  );
}

export default App;
